var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container mx-auto"},[_c('h1',{staticClass:"py-12 text-6xl text-green-900"},[_vm._v(" Times ")]),_c('times-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }